export const constants = {
  // Login actions
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",

  // Logout actions
  LOGOUT_REQUEST: "LOGOUT_REQUEST",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  LOGOUT_FAILURE: "LOGOUT_FAILURE",

  // User
  GET_USER_REQUEST: "GET_USER_REQUEST",
  GET_USER_SUCCESS: "GET_USER_SUCCESS",
  GET_USER_FAILURE: "GET_USER_FAILURE",

  // Collaborators
  GET_COLLABORATORS_REQUEST: "GET_COLLABORATORS_REQUEST",
  GET_COLLABORATORS_SUCCESS: "GET_COLLABORATORS_SUCCESS",
  GET_COLLABORATORS_FAILURE: "GET_COLLABORATORS_FAILURE",

  // Get All Evaluations
  GET_ALL_EVALUATIONS_REQUEST: "GET_ALL_EVALUATIONS_REQUEST",
  GET_ALL_EVALUATIONS_SUCCESS: "GET_ALL_EVALUATIONS_SUCCESS",
  GET_ALL_EVALUATIONS_FAILURE: "GET_ALL_EVALUATIONS_FAILURE",
};
